export const LOGO_SVG = require('./logo_white.svg')
export const ALBUM = require('./album.svg')
export const AUDIO = require('./audio.svg')
export const DOWNLOAD = require('./download.svg')
export const EXPORT = require('./export.svg')
export const ARROW_LEFT = require('./arrow_left.svg')
export const MAGNIFIER = require('./magnifier.svg')
export const PLATFORM_GRAY_SVG = require('./platform_gray.svg');
export const BPM_SOUNDS_LOGO_SVG = require('./BPM_Sounds_Logo.svg');
export const BPM_SUPEME_LOGO_WHITE_SVG = require('./BPM_Supeme_Logo_White.svg');
export const BPM_LATINO_LOGO_WHITE_SVG = require('./BPM_Latino_Logo_White.svg');
export const BPM_ANALYTIS = require('./BPM_Analytics.svg');


// WEBPACK FOOTER //
// ./src/assets/index.ts